import { useMutation } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useRegisterRider = () => {
  const { token } = useContext(AuthContext);

  const registerRider = async (formData) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/register/rider`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Rider registration failed');
    }

    return response.json();
  };

  return useMutation(registerRider);
};

export default useRegisterRider;
